import React, { useEffect, useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsKitSchemaManagementServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitSchemaManagementServices";

const AddNewStudyKitSchemaManagement = ({ getEIWRSKitSchemaManagementData }) => {
  let { studyId } = useParams();
  const [schemaName, setSchemaName] = useState("");
  const [kitPrefix, setKitPrefix] = useState("");
  const [kitStartingNumber, setKitStartingNumber] = useState("");
  const [kitSufix, setKitSufix] = useState("");
  const [kitJoiner, setKitJoiner] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const addNewEIWRSKitSchemaManagement = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.studyId = studyId;
    userData.schemaName = schemaName;
    userData.kitPrefix = kitPrefix;
    userData.kitStartingNumber = kitStartingNumber;
    userData.kitSuffix = kitSufix;
    userData.kitJoiner = kitJoiner;
    let data = await eiwrsKitSchemaManagementServices.addNewEIWRSKitSchemaManagement(
      userData
    );
    if (data?.statusCode === 200) {
      setSchemaName("");
      setKitPrefix("");
      setKitStartingNumber("");
      setKitSufix("");
      setKitJoiner("");
      getEIWRSKitSchemaManagementData()
    }
    setButtonLoader(false);
  };

  useEffect(() => {
    setSchemaName("");
    setKitPrefix("");
    setKitStartingNumber("");
    setKitSufix("");
    setKitJoiner("");
  }, []);

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">
          Schema Name{" "}
          <abbr title="Required" className="text-danger">
            *
          </abbr>
        </Form.Label>
        <Form.Control
          onChange={(e) => setSchemaName(e.target.value)}
          value={schemaName}
          className="br3"
          placeholder="Enter Schema Name"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">Kit Prefix</Form.Label>
        <Form.Control
          onChange={(e) => setKitPrefix(e.target.value)}
          value={kitPrefix}
          className="br3"
          placeholder="Enter Kit Prefix"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">Kit Starting Number <abbr className="text-danger">*</abbr></Form.Label>
        <Form.Control
          onChange={(e) => setKitStartingNumber(e.target.value)}
          value={kitStartingNumber}
          className="br3"
          placeholder="Enter Kit Starting Number"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">Kit Suffix</Form.Label>
        <Form.Control
          onChange={(e) => setKitSufix(e.target.value)}
          value={kitSufix}
          className="br3"
          placeholder="Enter Kit Suffix"
          type="text"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="fw-bold mb-1">Kit Joiner</Form.Label>
        <Form.Select
          value={kitJoiner}
          onChange={(e) => setKitJoiner(e.target.value)}
        >
          <option value="">Select Kit Joiner</option>
          <option value="-">-</option>
          <option value="_">_</option>
          <option value="/">/</option>
          <option value="~">~</option>
          <option value="|">|</option>
        </Form.Select>
      </Form.Group>
      <div className="text-end">
        <button
          disabled={!schemaName || !kitStartingNumber || buttonLoader}
          onClick={addNewEIWRSKitSchemaManagement}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Adding...
            </div>
          ) : (
            "Add Schema"
          )}
        </button>
      </div>
    </div>
  );
};

export default AddNewStudyKitSchemaManagement;
